
const routeList = [
	'/',
	'/account',
	'/settings',
	'/billing',
	'/billing/payment-method',
	'/billing/billing-type',
	'/billing/billing-method',
	'/budget-management',
	'/compilations',
	'/concierge-start',
	//'/concierge',
	/* 1.'statuses' is in plural to be it more REST full. But it may be harder to read, so, may be better singular. Let's wait for feedback.
	2. Numeric ids are not good here. Better to status names - separate route for every status as per the menu.
	*/
	'/concierge/statuses/:id',
	'/concierge/rides/:id',
	'/concierge/delivery/:id',
	'/forgot-password',
	'/reset-password',
	'/insights',
	'/insights-pdf',
	'/login',
	'/logout',
	'/onboarding',
	'/onboarding/account-pending',
	'/onboarding/program-suggestions',

	'/program-suggestions/',
	'/otp',
	'/sign-up',
	'/sign-up/create-credentials',
	'/sign-up/company-details',
	'/verify-email',
	'/employee-signup',

	'/people',
	'/people/:id',
	'/people/group/:id',
	'/programs',
	'/programs/id',
	'/programs/edit',

	'/travel-program'
] as const;

// 2. Create a type for all route paths
export type RoutePath = typeof routeList[number];

// 3. Create a routes object with keys and values as the route strings
export const routes: { [K in RoutePath]: K } = Object.fromEntries(
	routeList.map(r => [r, r])
) as { [K in RoutePath]: K };

// Add a type guard to check if a route has an :id parameter
type RouteWithId = Extract<RoutePath, `${string}:id${string}`>;

export const routeWithId = (route: RouteWithId, id: number) => {
	return route.replace(':id', id.toString());
}
// for future use for things like /?status=0&testParam=testValue, etc.
export const routeWithQuery = (route: RoutePath, params: Record<string, string | number>) => {
	if (!params || Object.keys(params).length === 0) {
		return route;
	}
	// Convert params object to URLSearchParams
	const searchParams = new URLSearchParams();
	Object.entries(params).forEach(([key, value]) => {
		searchParams.append(key, value.toString());
	});
	// Return route with query string
	const res = `${route}?${searchParams.toString()}`;
	return res;
}

//routeWithQuery('/concierge', { status: 1, testParam: 'testv' });


export default routes;
